module.exports = __webpack_public_path__ + "assets/img/6a8391530b88d90f999991246fbd19f6.png";